import {
  PRODUCTS_ADD_TO_SHOPPING_LIST,
  PRODUCTS_REMOVE_FROM_SHOPPING_LIST,
  REDUX_BASKET_UPDATED,
  REDUX_SHOPPING_LIST_UPDATED,
} from './actions';
import { PayloadProps, Layers } from './types';

export function createReducer(initialState: Layers) {
  return function reducer(
    // eslint-disable-next-line @typescript-eslint/default-param-last
    state = initialState,
    action: {
      type:
        | typeof REDUX_BASKET_UPDATED
        | typeof REDUX_SHOPPING_LIST_UPDATED
        | typeof PRODUCTS_ADD_TO_SHOPPING_LIST
        | typeof PRODUCTS_REMOVE_FROM_SHOPPING_LIST;
      payload: PayloadProps[];
    },
  ) {
    switch (action.type) {
      case REDUX_BASKET_UPDATED:
        return {
          ...state,
          basket: action.payload.map((item) => item.code),
          basketWithQuantity: action.payload,
        };
      case REDUX_SHOPPING_LIST_UPDATED:
        return {
          ...state,
          shoppingList: action.payload.map((item) => item.code),
        };
      case PRODUCTS_ADD_TO_SHOPPING_LIST:
        if (typeof action.payload === 'string') {
          return {
            ...state,
            shoppingList: [...state.shoppingList, action.payload],
          };
        }
        return state;
      case PRODUCTS_REMOVE_FROM_SHOPPING_LIST:
        if (typeof action.payload === 'string') {
          const shoppingList = new Set(state.shoppingList);
          shoppingList.delete(action.payload);

          return {
            ...state,
            shoppingList: Array.from(shoppingList),
          };
        }
        return state;
      default:
        return state;
    }
  };
}
